import { CreateWorldCupGroupScreen } from '../../../../components/worldcup/CreateWorldCupGroupScreen/CreateWorldCupGroupScreen';

export default function WorldCupGroupCreateRoute() {
  return <CreateWorldCupGroupScreen />;
}
